export default {
      id: "fact-usage",
      viewBox: "0 0 24 27",
      url: __webpack_public_path__ + "sprite.svg#fact",
      toString: function () {
        return this.url;
      }
    }